var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block"},[(_vm.notFound)?[_c('NotFoundComponent')]:[(_vm.isManagementCanBeViewed)?[_vm._t("default",null,{"isCanView":_vm.isManagementCanBeViewed,"isCanEdit":_vm.isManagementCanBeEditable})]:[_c('PermissionDenyComponent')]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }